export default {"src":"/evde-internet/_next/static/media/all-rewards.2d74513f.svg","height":36,"width":36};